import { apiFetch } from './client';

export interface ExtensionRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  number: string;
  display_name: string | null;
  sip_username: string;
  has_sip_password: boolean;
  assigned_user_id: string | null;
  voicemail_box_id: string | null;
  active: boolean;
  /** Optional FK to contacts(id) — internal-CID source (migration 0085). */
  internal_cid_contact_id: string | null;
  /** Freeform fallback shown as effective_caller_id_name when no
   *  contact is linked (migration 0085). */
  internal_cid_override: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateExtensionBody {
  number: string;
  display_name?: string | null;
  sip_password?: string;
  assigned_user_id?: string | null;
  voicemail_box_id?: string | null;
  customer_id?: string;
}

export type PatchExtensionBody = Partial<{
  display_name: string | null;
  sip_password: string;
  assigned_user_id: string | null;
  voicemail_box_id: string | null;
  active: boolean;
  /** Migration 0085 — link/unlink contact + freeform override. */
  internal_cid_contact_id: string | null;
  internal_cid_override: string | null;
}>;

export const extensions = {
  list: (p: { search?: string; limit?: number; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: ExtensionRow[] }>(`/api/extensions?${q}`);
  },
  get: (id: string) => apiFetch<ExtensionRow>(`/api/extensions/${id}`),
  create: (body: CreateExtensionBody) =>
    apiFetch<ExtensionRow & { sip_password?: string }>('/api/extensions', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, patch: PatchExtensionBody) =>
    apiFetch<ExtensionRow>(`/api/extensions/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  regeneratePassword: (id: string) =>
    apiFetch<{ password: string }>(`/api/extensions/${id}/regenerate-password`, { method: 'POST' }),
  remove: (id: string) => apiFetch<void>(`/api/extensions/${id}`, { method: 'DELETE' }),
};
